import { Spinner } from '@/components/common';
import type { SearchResult } from '@/types';
import styles from './SearchAutocomplete.module.css';

interface SearchAutocompleteProps {
  results: SearchResult[];
  isLoading: boolean;
  selectedIndex: number;
  onSelect: (result: SearchResult) => void;
  onHover: (index: number) => void;
  query: string;
}

export default function SearchAutocomplete({
  results,
  isLoading,
  selectedIndex,
  onSelect,
  onHover,
  query,
}: SearchAutocompleteProps) {
  if (isLoading) {
    return (
      <div className={styles.dropdown}>
        <div className={styles.loading}>
          <Spinner size="sm" />
          <span>Searching...</span>
        </div>
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className={styles.dropdown}>
        <div className={styles.noResults}>No recipes found for "{query}"</div>
      </div>
    );
  }

  return (
    <div className={styles.dropdown}>
      <ul className={styles.list}>
        {results.map((result, index) => (
          <li
            key={result.id}
            className={`${styles.item} ${index === selectedIndex ? styles.selected : ''}`}
            onClick={() => onSelect(result)}
            onMouseEnter={() => onHover(index)}
          >
            <div className={styles.itemContent}>
              <span className={styles.name}>{result.name}</span>
              <span className={styles.author}>by {result.author}</span>
            </div>
            {result.match_type === 'author' && (
              <span className={styles.matchBadge}>Author match</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
